<template>
  <v-row>
    <v-col
      cols="12"
      v-if="
        !hideHeader &&
          (!profile.isManager ||
            (list_item.show && profile.isManager && !showCards))
      "
    >
      <single-list-item
        color="performance"
        :button-text="list_item.buttonText"
        :label="list_item.label"
        v-on:click="showCards = true"
      >
        {{ list_item.detail }}
      </single-list-item>
      <v-btn
        v-if="showCards"
        color="performance"
        @click="showCards = false"
        dark
      >
        Go Back
      </v-btn>
    </v-col>
    <template v-if="showCards || !profile.isManager || hideHeader">
      <v-col cols="12">
        <v-card>
          <v-card-text>
            <v-row dense>
              <v-col cols="auto" class="text-h5 my-auto px-3">
                &#128075;
              </v-col>
              <v-col>
                <div class="font-weight-bold subtitle-1">
                  Who can view your feedback?
                </div>
                <div>
                  Your direct manager and company admin will have access to your
                  reviews. This data is not anonymous & your name will be linked
                  to your feedback.
                </div>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" v-for="user in users" :key="user.id">
        <review-card :user="user" :all-reviews="reviews(user.id)"></review-card>
      </v-col>
    </template>

    <v-footer
      app
      elevation="6"
      v-if="(!profile.isManager || showCards) && !hideHeader"
    >
      <v-container>
        <div class="text-center">
          <v-btn x-large color="performance" @click="finish">
            Finish Reviewing
          </v-btn>
        </div>
      </v-container>
    </v-footer>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";
import ReviewCard from "@/components/reviews/ReviewCard";
export default {
  name: "PendingReviewList",
  props: { hideHeader: { type: Boolean, default: false } },
  components: { ReviewCard },
  data: () => ({
    loading: false,
    showCards: false
  }),
  watch: {
    showCards(val, oldVal) {
      if (val != oldVal) {
        this.$emit("showCards", val);
      }
    }
  },
  computed: {
    list_item() {
      let label = "";
      let buttonText = "";
      let detail = "All Reviews have been Completed!";
      let show = false;
      if (this.pending.length > 0) {
        if (!this.profile.isManager) {
          label = `Please Complete These ${this.pendingUserCount} Reviews`;
          detail = "Your feedback is greatly appreciated";
        } else {
          label = "Reminder";
          buttonText = "Complete Reviews";
          detail = `You have ${this.pendingUserCount} people to review`;
        }
        show = true;
      }
      return { show, label, buttonText, detail };
    },
    users() {
      return this._.uniqWith(
        this.pending.map(x => x.user),
        this._.isEqual
      );
    },
    reviews() {
      return userId => {
        return this.pending.filter(x => x.user.id == userId);
      };
    },
    pendingUserCount() {
      return this._.values(this._.groupBy(this.pending, "user.id")).length;
    },
    ...mapGetters({ pending: "review/pending", profile: "profile/profile" })
  },
  created() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = true;
      Promise.all([this.$store.dispatch("review/getPendingReviews")])
        .catch(error => {
          this.logError(error);
          this.$root.$alert(
            "Error Occurred",
            "An error occured while loading your reviews."
          );
        })
        .finally(() => {
          this.loading = false;
        });
    },
    finish() {
      if (this.profile.isManager) {
        this.loadData();
        this.showCards = false;
      } else {
        this.$router.push({ path: "/" });
      }
    }
  }
};
</script>
